module.exports = __webpack_public_path__ + "img/prospect1.088cc24c.jpeg";